import getParameterFromURL from './getParameterFromURL';
import saveRandomValue from './saveRandomValue';

type DiscountScreenKey = 'p20v54_discountScreen_fortune' | 'p20v1_discountScreen_scratch';

// Возвращает активный ключ AB-теста для текущей ссылки или null.
// Условия зеркалят пейвол (getLinkToPaymentPage.js): tariff=v41 + everydoggyV5
// + !darkTheme + соответствующий config + включённый Firebase-флаг.
function getActiveDiscountScreenKey(): DiscountScreenKey | null {
  const config = getParameterFromURL('config');
  const tariff = getParameterFromURL('tariff') || null;
  const everydoggyV5 = getParameterFromURL('everydoggyV5') === 'true';
  const darkTheme = getParameterFromURL('darkTheme') === 'true';
  const firebase = window.firebaseConfigData;

  if (tariff !== 'v41' || !everydoggyV5 || darkTheme || !firebase) {
    return null;
  }

  if (config === 'customV2' && firebase.p20v1_discountScreen_scratch === 'true') {
    return 'p20v1_discountScreen_scratch';
  }

  return null;
}

// Распределение 50/50. Вызывается на шаге receive_email.
// saveRandomValue шлёт AB_TEST-событие на каждый вызов (в т.ч. при чтении уже
// назначенной группы) — это нужно, чтобы при перезагрузке/повторном заходе на шаг
// событие срабатывало снова. От дублей в рамках одного захода защищает вызывающая
// сторона (gate по currentStep === 'receive_email' + ref в receiveEmail).
export function assignDiscountScreenAbTest(): void {
  const key = getActiveDiscountScreenKey();
  if (!key) return;
  saveRandomValue(2, key, 'A', 'B', 50, 50);
}

// Вариант B активен — показываем DiscountCards вместо customV2_specialOffer_v2.
export function isDiscountScreenVariantB(): boolean {
  const key = getActiveDiscountScreenKey();
  if (!key) return false;
  return localStorage.getItem(key) === 'B';
}
